//
// User logged reports other user
//
import { API_USER } from '../config';
import { sendRequest } from '../send_request';

export const userReportRequest = async (userName) => await sendRequest(API_USER.REPORT_USER_URL(userName), 'POST', null);